<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <template v-if="tabselected === 'content1'">
      <div class="d-flex align-items-start justify-content-between flex-wrap pb-1">
        <div class="pr-3 mb-3">
          <div class="generalTitleItemModal">Id contrato</div>
          <div>{{ cuotes.contractId }}</div>
        </div>
        <div class="pr-3 mb-3">
          <div class="generalTitleItemModal">Cantidad por cuota</div>
          <div>{{ cuotes.amount }}€</div>
        </div>
        <div class="pr-3 mb-3">
          <div class="generalTitleItemModal">Número de cuotas</div>
          <div>{{ cuotes.numFees }}</div>
        </div>
        <div class="pr-3 mb-3">
          <div class="generalTitleItemModal">Estado del plan</div>
          <div
            v-bind:class="{ 'border-success text-success': cuotes.status == 'STARTED', 'border-danger text-danger': cuotes.status == 'CANCELED', 'border-info text-info': cuotes.status == 'CREATED', 'border-light text-light bg-danger': cuotes.status == 'UNPAID', 'border-dark text-muted': cuotes.status == 'FINISHED', }"
            class="badge border text-uppercase">{{ cuotes.status || "-" }}</div>
        </div>
      </div>
      <div class="overflow-auto">
        <table class="table mt-3">
          <thead>
            <tr>
              <th class="py-4 align-middle">
                Nº de cuota
              </th>
              <th class="py-4 align-middle">
                Fecha esperada del cobro
              </th>
              <th class="py-4 align-middle">
                Fecha del pago
              </th>
              <th class="py-4 align-middle">
                Cuota
              </th>
              <th class="py-4 align-middle">
                Operaciones
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cuote, index) in fees" :key="index">
              <td class="align-middle py-4">{{ cuote.num }}</td>
              <td class="align-middle py-4">{{ $dateBackToFront(cuote.expectedDate) }}</td>
              <td class="align-middle py-4">{{ $dateBackToFront(cuote.paymentDate) }}</td>
              <td id="estados" class="align-middle py-4">
                <div
                  v-bind:class="{ 'border-success text-success': cuote.status == 'PAID', 'border-danger text-danger': cuote.status == 'CANCELED', 'border-info text-info': cuote.status == 'PENDING', 'border-light text-light bg-danger': cuote.status == 'UNPAID', 'border-warning text-warning': cuote.status == 'PROCESSING', }"
                  class="badge border text-uppercase">{{ cuote.status || "-" }}</div>
              </td>
              <td id="operaciones" class="align-middle py-4">
                <div class="dropdown dropdown-inherit" v-if="cuote.status == 'UNPAID'">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a href="#" class="dropdown-item py-3 px-4"
                      @click="selectTab('content2');cuoteNum = cuote.num">
                      Penalización
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
    </template>
    <template v-if="tabselected === 'content2'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Se va a realizar una petición de penalización</p>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h-100 d-flex justify-content-between">
            <div>
              <button
                class="btn generalSecondaryButton"
                @click="selectTab('content1')"
                :disabled="loading"
              >
                Atrás
              </button>
            </div>
            <div>
              <img v-if="loading" src="../../../../../assets/loaderPrimary.svg" height="40" alt="">
              <button
                class="btn btn-primary generalPrimaryButton"
                v-if="!loading"
                @click="penalizacion()"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="tabselected === 'content3'">
      <div class="row mt-3">
        <div class="col-12">
          <p>Penalización realizado correctamente</p>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '../../../Shared/Modal.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';

export default {
  name: 'ContractDetail',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId'
  ],
  data() {
    return {
      classes: this.class,
      cuotes: '',
      fees: '',
      currentPage: 0,
      numberPages: 0,
      tabselected: "content1",
      cuoteNum: 0,
      loading: false,
    };
  },
  updated() {
    this.loadContractData();
  },
  components: {
    Modal,
    Pagination
  },
  methods: {
    loadContractData() {
      axios.get(`/contract/${this.contractId}/payment-plan`)
        .then((response) => {
          this.cuotes = response.data;
          this.paginacion(response.data.fees)
          this.numberPages = Math.ceil(response.data.fees.length / 5)
        });
    },
    paginacion(value) {
      let start = this.currentPage * 5
      console.log('start : ' + start)
      this.fees = value.slice(start, start + 5)
      console.log(this.fees)
    },
    selectTab(id) {
      this.tabselected = id;
    },
    penalizacion() {
      this.loading = true;
      const bodyToSend = {
        numReceipt: this.cuoteNum
      }
      axios.post(`/payment/${this.contractId}/payment-plan/fees/commission`, bodyToSend)
        .then((response) => {
          console.log(response)
          this.loading = false;
          this.tabselected = "content3";
        })
        .catch(() => {
          this.loading = false
        });
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadContractData();
    },
    onClose() {
      this.classes = this.class,
      this.currentPage = 0,
      this.numberPages = 0,
      this.tabselected = "content1",
      this.cuoteNum = 0,
      this.loading = false
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#estados {
  text-align: center;
}
</style>
